import { render, staticRenderFns } from "./placement.vue?vue&type=template&id=f0306352&"
import script from "./placement.vue?vue&type=script&lang=js&"
export * from "./placement.vue?vue&type=script&lang=js&"
import style0 from "./placement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports